/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Note_AdminInputs */



/**
* | output |
* | --- |
* | "Chats in this project are private. As a project admin you see everyone's chats here, with their attached files and AI-created documents; other members only s..." |
*
* @param {Project_Private_Chats_Note_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_note_admin = /** @type {((inputs?: Project_Private_Chats_Note_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Note_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Chats in diesem Projekt sind privat. Als Projekt-Admin sehen Sie hier die Chats aller Mitglieder samt angehängten Dateien und KI-erstellten Dokumenten; andere Mitglieder sehen nur ihre eigenen, es sei denn, sie dürfen die Chats aller Mitglieder sehen.")
	return /** @type {LocalizedString} */ ("Chats in this project are private. As a project admin you see everyone's chats here, with their attached files and AI-created documents; other members only see their own, unless they are allowed to see everyone's chats.")
});